import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-filter"
export default class extends Controller {
  static targets = ["distributorSelect", "warehouseSelect", "warehouseRow"]
  static values = { warehouses: Object }

  connect() {
    this.updateWarehouses()
  }

  distributorChanged() {
    this.warehouseSelectTarget.dataset.selected = ""
    this.updateWarehouses()
  }

  updateWarehouses() {
    const distributorId = this.distributorSelectTarget.value
    const warehouses = this.warehousesValue[distributorId] || []
    const select = this.warehouseSelectTarget
    const selectedId = String(select.dataset.selected || "")

    select.innerHTML = ""
    const blank = new Option(select.dataset.placeholder, "")
    select.appendChild(blank)

    warehouses.forEach(w => {
      const option = new Option(w.name, w.id)
      if (String(w.id) === selectedId) option.selected = true
      select.appendChild(option)
    })

    const visible = distributorId !== "" && warehouses.length > 0
    this.warehouseRowTarget.classList.toggle("d-none", !visible)

    if (!visible) select.value = ""
  }
}
